var render = function render(){var _vm=this,_c=_vm._self._c;return _c('date-picker',{attrs:{"name":_vm.dpname,"config":_vm.options},on:{"dp-change":_vm.changeValue},model:{value:(_vm.dpdate),callback:function ($$v) {_vm.dpdate=$$v},expression:"dpdate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }